import React, {useEffect} from 'react';
import "./ProjComp.css";
import GitHubIcon from '@material-ui/icons/GitHub';
import LaunchIcon from '@material-ui/icons/Launch';

import AOS from "aos";
import "aos/dist/aos.css";


function ProjComp({name, desc, tech, imgSrc}) {

    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div className="ProjComp" data-aos={"fade-up"} data-aos-delay="300">
            <div className="project-content" >
                <p className="proj-overline">Featured Project</p>
                <h3>{name}</h3>
                <div className="proj-desc">
                <p>{desc}</p>
                </div>
                <h4 className="proj-tech-list">
                    {tech}
                </h4>
                <div className="proj-link">
                    <a><GitHubIcon className="proj-icon"/></a>
                    <a><LaunchIcon className="proj-icon"/></a>
                </div>
            </div>

            <div className="proj-img" >
                <img src={imgSrc}></img>
            </div>
        </div>
    )
}

export default ProjComp
